"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BridgeProvider = exports.BridgeContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const react_1 = require("react");
const typedi_1 = __importDefault(require("typedi"));
exports.BridgeContext = (0, react_1.createContext)(null);
function BridgeProvider({ children }) {
    // @ts-ignore - typedi types are not correct
    const bridge = typedi_1.default.get(bridge_schema_1.BridgeInterface);
    return ((0, jsx_runtime_1.jsx)(exports.BridgeContext.Provider, { value: bridge, children: children }));
}
exports.BridgeProvider = BridgeProvider;
